import apiRequest from '@/redux/requests/apiRequest.js';

export const get = (url, config = {}) => apiRequest('GET', url, config);
export const post = (url, config = {}) => apiRequest('POST', url, config);
export const put = (url, config = {}) => apiRequest('PUT', url, config);
export const del = (url, config = {}) => apiRequest('DELETE', url, config);
